import React from 'react'
import {Form , Button } from "semantic-ui-react";
import { useFormik } from 'formik';
import * as Yup from "yup" ;
import { useMutation } from '@apollo/client';

import { toast } from 'react-toastify';

import "./ComfirmDeletePublic.scss" ;
import { DELETE_PUBLI } from '../../../../../../gql/publication';

 export default function ComfirmDeletePublic (props) {
    const {setShowModal, currentTitle , publication, refetch } = props ;
    const[ deletePublication ] = useMutation(DELETE_PUBLI);
    

   
    
    
      const formik = useFormik({
        initialValues : {
          idPublication: "", 
        },
        validationSchema: Yup.object ({
          username: Yup.string().required()
          .oneOf([Yup.ref("repeatUsername")]),
          repeatUsername: Yup.string().required()
              .oneOf([Yup.ref("username")])
          
        }),
        onSubmit: async(FormData) => {
          try{
            await deletePublication({
                variables: {
                    idPublication:publication._id
                },

                
            }
            );
            toast.success (" Publicacion eliminada 😬 ");

             setTimeout(() =>  setShowModal (false),1000);

            
          } catch (error) { 
            toast.error(" Publicacion eliminada ")
            
            setShowModal(false);
            
          }
  
        }   
  
      })
  
   
    

  return (

    <Form className='confirm-form' onSubmit={formik.handleSubmit}>
        
        <h2 >Ingresa el titulo de la publicacion en los dos campos.</h2>
        
        <Form.Input 
         placeholder = {publication.title}name= "username" value={formik.values.username} onChange={formik.handleChange}
        error={formik.errors.title && true}
        />
        <Form.Input 
         placeholder = {publication.title} name= "repeatUsername" value={formik.values.repeatUsername} onChange={formik.handleChange}
        error={formik.errors.repeatTitle && true}
        />


        <Button type = "submit" className='btn-remove' >Borrar</Button>

    </Form>
    
    
  );

}


